import { render, staticRenderFns } from "./vat-select.app.vue?vue&type=template&id=f968cf84&"
import script from "./vat-select.app.vue?vue&type=script&lang=js&"
export * from "./vat-select.app.vue?vue&type=script&lang=js&"
import style0 from "./vat-select.app.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports